module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Biographies")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Henry Fitzalan, Earl of Arundel")]), _vm._v(" Traditionally viewed as a Catholic and conservative nobleman, Arundel was involved in the 1549 coup that engineered Somerset’s downfall, though he quickly grew dissatisfied with the direction of events as Dudley gained the upper hand over Wriothesley, and was eventually removed from the council. Arundel then allied with Somerset in a bid to remove Dudley in a bizarre assassination plot. Exiled from court and heavily fined for his part in the scheme, Arundel was restored to favour when Dudley realized he was unable to do without his support. Arundel’s revenge came shortly afterwards when his rallying speech announcing his defection to Mary’s cause prompted Mary to be proclaimed in London by the council.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Kat Ashley")]), _vm._v(" Elizabeth’s loose-tongued gentlewoman, whose revelations about the princess’s behaviour with Sir Thomas Seymour cost her her job.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Cheke")]), _vm._v(" Edward’s tutor, whose reforming religious outlook heavily influenced the king’s own faith.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Richard Cox")]), _vm._v(" Edward’s almoner and tutor alongside John Cheke.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thomas Cranmer")]), _vm._v(" Archbishop of Canterbury and Edward’s godfather. Hailed as the architect of the English Reformation, Cranmer dictated the pace of religious reform during Edward’s reign in an attempt to placate both Protestants and Catholics.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Dudley, Viscount Lisle, Earl of Warwick and Duke of Northumberland")]), _vm._v(" The son of a traitor, Dudley managed to climb the ranks of Henry’s court as an accomplished horseman and soldier. Having grown increasingly dissatisfied with Somerset’s leadership, Dudley’s ruthless suppression of Kett’s rebellion was followed shortly by his seminal role in organizing the October 1549 coup. A political chameleon, Dudley finally sided with the reformers and Protestants once he realized where Edward’s true feelings lay. Having managed to gain control of the Privy Chamber, Dudley became President of the Council. His careful manipulation of Edward allowed the king to believe that he was increasingly grasping the reins of power. Dudley nevertheless retained control until the last, and having acquiesced with Edward’s decision to place Lady Jane Grey upon the throne, went to his death upon the scaffold recanting both his former life and his Protestant faith.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Barnaby Fitzpatrick")]), _vm._v(" School friend and close confidant of Edward, whose letters to him whilst in France reveal the close intimacy and affection between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Stephen Gardiner")]), _vm._v(" Bishop of Westminster and a powerful voice on Henry’s council, Gardiner found himself cold-shouldered when left out of Henry’s will and consequently isolated for the rest of Edward’s reign. A staunch critic of the Edwardian Reformation, he opposed the new Prayer Book, which resulted in his imprisonment in the Tower, where he remained for the duration of Edward’s reign.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("John Gates")]), _vm._v(" Gentleman of the Privy Chamber and supporter of Dudley, who ended his life on the scaffold with his master.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Lady Jane Grey")]), _vm._v(" Protestant bluestocking daughter of the Duke of Suffolk who, having been named by Edward as an heir to the throne, was promptly married off to Dudley’s son, Guildford. When Edward’s condition deteriorated, his decision to appoint her as his heir apparent propelled Jane to the throne on 10 July 1553. Queen for nine days, she was deserted by her own nobility in favour of Mary, and was forced to abdicate. Imprisoned in the Tower, she was executed upon the scaffold the following year.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Henry Grey, Marquess of Dorset and Duke of Suffolk")]), _vm._v(" Wealthy magnate who blundered first into supporting Sir Thomas Seymour’s schemes before becoming a supporter of Dudley. As father of Lady Jane Grey, his hopes of founding a new royal dynasty upon Edward’s death were dashed within days, when support for his daughter’s reign collapsed.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William Herbert, Earl of Pembroke")]), _vm._v(" Gentleman of Henry’s Privy Chamber who became one of the most powerful members of the nobility due to his military strength. His decision to support Dudley in the October 1549 coup doomed Somerset’s protectorate. Herbert was consequently rewarded with lavish grants of lands and titles. Considered by observers to be one of the three most important members of the council, alongside Dudley and Northampton.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Robert Kett")]), _vm._v(" Norfolk gentry landowner whose surprising decision to lead a camp of thousands of rebels into Norwich resulted in the eponymous rebellion during the ‘commotion time’, eventually claiming some six thousand rebel lives.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hugh Latimer")]), _vm._v(" Protestant preacher whose inflammatory sermons set the tone for reform at court.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Richard Morison")]), _vm._v(" Polemicist under Henry VIII and later Imperial ambassador under Edward.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William Paget")]), _vm._v(" Private Secretary of Henry VIII and close confidant of Edward Seymour. Paget was instrumental in ensuring that Seymour was appointed Lord Protector, though growing increasingly dissatisfied with Seymour’s rule, Paget eventually deserted his ally in return for a peerage. Permanently tainted by his association with Seymour, Paget was later arrested and heavily fined when an attempted assassination plot against Dudley backfired.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thomas Palmer")]), _vm._v(" Close supporter of Dudley, whose evidence enabled the Duke of Somerset to be framed for attempted murder. Palmer later followed Dudley to the scaffold for his part in supporting Queen Jane.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Katherine Parr")]), _vm._v(" Henry VIII’s sixth wife, who shared her enthusiasm for learning with Edward and Elizabeth. She began an affair with Sir Thomas Seymour almost immediately after Henry’s death, and married him shortly afterwards. She fell out publicly with the Duchess of Somerset. She became pregnant in 1548 and gave birth to a child, Mary, in September that year, but she died a few days later, probably of puerperal fever.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William Parr, Marquess of Northampton")]), _vm._v(" Katherine Parr’s brother, whose support for Dudley gained him influence and power on the council.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Edward Seymour, Earl of Hertford and Duke of Somerset")]), _vm._v(" Edward’s maternal uncle through his sister Jane, his military prowess allowed him to rise quickly to prominence during the fading years of Henry’s reign. Upon Henry’s death he became Protector of the Realm, having been granted unprecedented powers through which to exercise his authority. Both a reformer and liberal in his social attitudes. His leniency towards the rebels of the 1549 commotions ultimately proved to be his downfall, engineered in a coup planned by Dudley and Wriothesley. He was rehabilitated to power the following year. Somerset’s manipulation of his popularity and relentless scheming against Dudley resulted in his final humiliation and execution.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thomas Seymour, 1st Baron Seymour")]), _vm._v(" Edward’s younger uncle, Seymour lived in the shadow of his elder brother, bitter at his success and disappointed that he had not been afforded a share of it. Appointed Lord Admiral, Seymour began an affair with and then married Queen Katherine Parr within months of Henry’s death. Katherine’s pregnancy did not prevent Seymour from extending his dalliances towards Elizabeth, though when his wife died shortly after childbirth, Seymour was left isolated. Having struggled to persuade Edward to appoint him Governor of the Realm, he plotted to kidnap the king and in all probability engineer civil war. Discovered entering Edward’s chamber late at night, Seymour was found guilty of treason and executed in March 1549.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Anne Stanhope, Duchess of Somerset")]), _vm._v(" Somerset’s haughty wife, whose public falling out with Katherine Parr helped contribute to the growing enmity between the Seymour brothers. Universally unpopular for her pride and lavish lifestyle, she remained a strong influence upon her husband’s Protestant attitudes.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sir Michael Stanhope")]), _vm._v(" The Duchess of Somerset’s brother; Head of the Privy Chamber under Somerset, he was later executed for his part in Somerset’s conspiracy.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Henry Howard, Earl of Surrey")]), _vm._v(" Brash and arrogant son of the Duke of Norfolk, whose use of the royal arms and attempts to gain control of Edward during the dying days of Henry’s reign resulted in his execution.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("William Thomas")]), _vm._v(" Clerk to the Council, whose secret correspondence with Edward over policy suggests that Edward may have been more in control of government matters than previously thought. Thomas’s friendship with Dudley, however, suggests that the entire relationship may have been contrived for Dudley’s own benefit in order to keep Edward in check.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Elizabeth Tudor")]), _vm._v(" Edward’s stepsister from Henry VIII’s marriage to Anne Boleyn. Despite an embarrassing interlude with his uncle, Thomas Seymour, she remained on good terms with her younger brother, sharing a similar Protestant outlook no doubt fostered by the tutors they shared, Roger Ascham and Jean Belmain.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mary Tudor")]), _vm._v(" Edward’s elder stepsister. The daughter of Henry VIII and Katherine of Aragon, she remained firmly committed to the Catholic faith. Her defiance of the Edwardian Reformation made her household a touchstone for Catholic resistance. Held in deep suspicion by the council, her confrontations with Edward over her right to hear mass marked a nadir in their relationship. Excluded from the succession under Edward’s final will, Mary’s surprising victory over Northumberland and Queen Jane was largely due to a groundswell of popular support, and might justifiably be counted as one of the few successful rebellions of English history. Mary’s ‘annus mirabilis’ was the high point of a reign largely beset by failure. Her marriage to Philip II was greeted with xenophobic hostility, whilst her desire to return England to Rome was rounded upon by Protestant polemicists, whose influence in creating the portrait of ‘bloody Mary’ remains in strong currency to this day.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Thomas Wriothesley, Earl of Southampton")]), _vm._v(" Lord Chancellor under Henry VIII, he was responsible for the Earl of Surrey’s downfall and execution. An important conservative, he was brought down by Somerset in his attempt to be made Protector. Later a key plotter in the October 1549 coup, Wriothesley seemed likely to take charge of the council, but was outmanoeuvred by Dudley who forced his eventual disgrace, leading to his possible suicide.")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Imperial Ambassadors")]), _c('br'), _vm._v(" Jehan Scheyfve"), _c('br'), _vm._v(" Van der Delft"), _c('br'), _vm._v(" Simon Renard")]), _vm._v(" "), _c('p', {
    staticClass: "bibliographyEntry",
    staticStyle: {
      "text-indent": "-5%",
      "margin-left": "5%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("French Ambassadors")]), _c('br'), _vm._v(" Odet de Selve"), _c('br'), _vm._v(" Boisdauphin"), _c('br'), _vm._v(" Maréchal St André"), _c('br'), _vm._v(" Francois de Scepeaux, Maréchal de Vieilleville")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ba5ca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466805798_fm02.vue
// module id = 72
// module chunks = 0